import {
	faCircleInfo,
	faCircleXmark,
	faDownload,
	faEdit,
	faFile,
	faFileExcel,
	faFilePdf,
	faFileWord,
	faImage,
	faInfoCircle,
	faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, Card } from 'react-bootstrap';
import { PHP } from '../../utils/axiosConfig';
import FileUploadModal from './FileUploadModal';
import { useState } from 'react';
import ConfirmationModal from '../../components/formComponents/ConfirmationModal';
import { useAuth } from '../../context/AuthContext';

const FileCard = ({ file, fetchFiles }) => {
	const { user } = useAuth();
	const php = PHP();
	const [showUploadModal, setShowUploadModal] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [confirmSuccess, setConfirmSuccess] = useState(false);
	const [confirmFailure, setConfirmFailure] = useState(false);
	const [showInfo, setShowInfo] = useState(false);

	const getFile = (e) => {
		let formData = new FormData();
		formData.append('viewFile', 1);
		formData.append('file', file.name);

		//use file directory or the viewed file as the passed user id for admin access of file
		if (user?.userLevel === 'admin' && user._id !== file.directory) {
			formData.append('userID', file.directory);
		}
		php
			.post('fileRepo.php', formData, { responseType: 'arraybuffer' })
			.then((res) => {
				if (res.status === 200) {
					const type = res.headers['content-type'];
					// Create a blob from the response data
					const blob = new Blob([res.data], { type: type });
					// Create a url for the Blob
					const url = window.URL.createObjectURL(blob);
					window.open(url, '_blank');
					// Clean up
					window.URL.revokeObjectURL(url);
				}
			})
			.catch((err) => console.log(err));
	};

	const downloadFile = () => {
		let formData = new FormData();
		formData.append('viewFile', 1);
		formData.append('file', file.name);
		//use file directory or the viewed file as the passed user id for admin access of file
		if (user?.userLevel === 'admin' && user._id !== file.directory) {
			formData.append('userID', file.directory);
		}
		php
			.post('fileRepo.php', formData, { responseType: 'arraybuffer' })
			.then((res) => {
				if (res.status === 200) {
					const type = res.headers['content-type'];
					// Create a blob from the response data
					const blob = new Blob([res.data], { type: type });
					// Create a url for the Blob
					const url = window.URL.createObjectURL(blob);
					// Create a hidden anchor element for downloading the file.
					const a = document.createElement('a');
					a.href = url;
					a.download = file.name; // Set the desired file name.
					a.style.display = 'none';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url); // Clean up.
					document.body.removeChild(a);
				}
			})
			.catch((err) => console.log(err));
	};

	const deleteFile = () => {
		const formData = new FormData();
		formData.append('deleteFile', 1);
		formData.append('file', file.name);
		formData.append('id', file.id);
		//use file directory or the viewed file as the passed user id for admin access of file
		if (user?.userLevel === 'admin' && user._id !== file.directory) {
			formData.append('userID', file.directory);
		}
		php
			.post('fileRepo.php', formData)
			.then((res) => {
				if (res.status === 200) {
					setConfirmSuccess(true);
				}
			})
			.catch((err) => {
				console.log(err);
				setConfirmFailure(true);
			});
	};

	const editFile = () => {
		//Open a modal to edit the form
	};

	return (
		<>
			<div className={showInfo ? 'file rotated' : 'file'}>
				<Card className="front">
					<div className="info-icon">
						<FontAwesomeIcon
							icon={faInfoCircle}
							onClick={() => setShowInfo(!showInfo)}
						/>
					</div>
					<div className="file-icon">
						{file.type === 'pdf' ? (
							<FontAwesomeIcon icon={faFilePdf} className="primaryColor" />
						) : file.type === 'png' ||
						  file.type === 'jpg' ||
						  file.type === 'jpeg' ? (
							<FontAwesomeIcon icon={faImage} className="primaryColor" />
						) : file.type === 'doc' || file.type === 'docx' ? (
							<FontAwesomeIcon icon={faFileWord} className="primaryColor" />
						) : file.type === 'xls' || file.type === 'xlsx' ? (
							<FontAwesomeIcon icon={faFileExcel} className="primaryColor" />
						) : (
							<FontAwesomeIcon icon={faFile} className="primaryColor" />
						)}
					</div>
					<Card.Body>
						<Card.Title>{file.humanName || file.name}</Card.Title>

						<Button
							type="button"
							value={file.name}
							onClick={getFile}
							variant="secondary"
						>
							View
						</Button>
					</Card.Body>
				</Card>
				<Card className="back">
					<div className="close-icon">
						<FontAwesomeIcon
							icon={faCircleXmark}
							onClick={() => setShowInfo(!showInfo)}
						/>
					</div>
					<Card.Body>
						<Card.Title>
							File:
							<br />
							{file.name}
						</Card.Title>
						<Card.Title>
							Notes:
							<br />
							{file.description}
						</Card.Title>
						<Card.Title>
							Upload Date:
							<br />
							{new Date(file.upload_date).toDateString()}
						</Card.Title>
						<ButtonGroup inline>
							<Button variant="dark" onClick={editFile}>
								<FontAwesomeIcon icon={faEdit} />
							</Button>
							<Button variant="primary" onClick={downloadFile}>
								<FontAwesomeIcon icon={faDownload} />
							</Button>
							<Button
								variant="danger"
								onClick={() => setShowConfirmModal(true)}
							>
								<FontAwesomeIcon icon={faTrash} color="white" />
							</Button>
						</ButtonGroup>
					</Card.Body>
				</Card>
			</div>
			<ConfirmationModal
				showModal={showConfirmModal}
				setShowModal={setShowConfirmModal}
				confirmAction={deleteFile}
				cancelButton={true}
				title={'Delete File'}
				message={
					<>
						Are you sure you want to delete?
						<br />
						<strong>
							{file.humanName ? `${file.humanName} (${file.name})` : file.name}
						</strong>
					</>
				}
				confirmButtonVariant={'danger'}
				confirmText={'Delete'}
				successMessage={'File was successfully deleted.'}
				confirmSuccess={confirmSuccess}
				confirmFailure={confirmFailure}
				callback={fetchFiles}
				useTimeout={true}
			/>

			<FileUploadModal
				showModal={showUploadModal}
				setShowModal={setShowUploadModal}
				file={file}
			/>
		</>
	);
};

export default FileCard;
